import { assertString } from '@Utils/assert';

import RequestUrls from '@Constants/RequestUrlsConstants';
import MessageBroker from '@Services/MessageBroker';

// eslint-disable-next-line import/prefer-default-export
export function fetchSortingProperties(params) {
  assertString(params.resultName, 'resultName');
  assertString(params.databaseId, 'databaseId');
  assertString(params.context, 'context');

  return MessageBroker.send(RequestUrls.sortProperties, params);
}
